<ng-container *ngIf="loading; else contentLoaded">
  <h4 class="h4--skeleton"></h4>
  <div class="account-history-orders-group">
    <p class="account-history-orders-group-title-skeleton"></p>
    <div class="account-history-orders-group-date">
      <p class="account-history-orders-group-date-title-skeleton"></p>
      <div class="account-history-order-container account-history-order-container-skeleton">
        <div class="account-history-order-skeleton"></div>
        <div class="account-history-order-rating-skeleton"></div>
      </div>
      <p class="account-history-orders-group-date-title-skeleton"></p>
      <div class="account-history-order-container account-history-order-container-skeleton">
        <div class="account-history-order-skeleton"></div>
        <div class="account-history-order-rating-skeleton"></div>
      </div>
    </div>
  </div>
  <div class="account-history-orders-group">
    <p class="account-history-orders-group-title-skeleton"></p>
    <div class="account-history-orders-group-date">
      <p class="account-history-orders-group-date-title-skeleton"></p>
      <div class="account-history-order-container account-history-order-container-skeleton">
        <div class="account-history-order-skeleton"></div>
        <div class="account-history-order-rating-skeleton"></div>
      </div>
      <div class="account-history-order-container account-history-order-container-skeleton">
        <div class="account-history-order-skeleton"></div>
        <div class="account-history-order-rating-skeleton"></div>
      </div>
      <p class="account-history-orders-group-date-title-skeleton"></p>
      <div class="account-history-order-container account-history-order-container-skeleton">
        <div class="account-history-order-skeleton"></div>
        <div class="account-history-order-rating-skeleton"></div>
      </div>
    </div>
  </div>
  <div class="account-history-orders-group">
    <p class="account-history-orders-group-title-skeleton"></p>
    <div class="account-history-orders-group-date">
      <p class="account-history-orders-group-date-title-skeleton"></p>
      <div class="account-history-order-container account-history-order-container-skeleton">
        <div class="account-history-order-skeleton"></div>
        <div class="account-history-order-rating-skeleton"></div>
      </div>
      <p class="account-history-orders-group-date-title-skeleton"></p>
      <div class="account-history-order-container account-history-order-container-skeleton">
        <div class="account-history-order-skeleton"></div>
        <div class="account-history-order-rating-skeleton"></div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #contentLoaded>
  <ng-container *ngIf="orders?.length; else emptyState">
    <h4 class="account-history-orders-title">{{ 'your_orders' | translate }}</h4>
    <div *ngIf="inProgressGroups?.length" class="account-history-orders-group">
      <p class="account-history-orders-group-title ods-typography-body-s-bold">{{ 'in_progress' | translate }}</p>
      <div *ngFor="let group of inProgressGroups" class="account-history-orders-group-date">
        <p class="account-history-orders-group-date-title ods-typography-body-s-regular">{{ group.day }}</p>
        <div *ngFor="let order of group.orders" class="account-history-order-container">
          <order [order]="order" (click)="onOrderClick(order)"></order>
        </div>
      </div>
    </div>
    <div *ngIf="scheduledGroups?.length" class="account-history-orders-group">
      <p class="account-history-orders-group-title ods-typography-body-s-bold">{{ 'scheduled_' | translate }}</p>
      <div *ngFor="let group of scheduledGroups" class="account-history-orders-group-date">
        <p class="account-history-orders-group-date-title ods-typography-body-s-regular">{{ group.day }}</p>
        <div *ngFor="let order of group.orders" class="account-history-order-container">
          <order [order]="order" (click)="onOrderClick(order)"></order>
        </div>
      </div>
    </div>
    <div *ngIf="completedGroups?.length" class="account-history-orders-group">
      <p class="account-history-orders-group-title ods-typography-body-s-bold">{{ 'previous_' | translate }}</p>
      <div *ngFor="let group of completedGroups" class="account-history-orders-group-date">
        <p class="account-history-orders-group-date-title ods-typography-body-s-regular">{{ group.day }}</p>
        <div *ngFor="let order of group.orders" class="account-history-order-container">
          <order [order]="order" (click)="onOrderClick(order)" (orderRate)="onOrderRate(order, $event)"></order>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #emptyState>
    <box-empty-state [options]="emptyStateOptions"></box-empty-state>
  </ng-template>
</ng-template>
